<template>
  <b-card class="text-center border border-danger">
    <b>Bespoke reports do not come with this content.</b> <br>
  </b-card>
</template>

<script>

import { BCard } from 'bootstrap-vue'

export default {
  name: 'BespokeBlockingOverlay',
  components: {
    BCard,
  },
}
</script>
